var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"bar-style progress",staticStyle:{"border-radius":"15px"}},[_c('div',{style:({
            width: `${_vm.percentage}%`,
            'background-color': _vm.percentage && _vm.color,
          }),attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":"100"}})]),_c('div',{staticClass:"bar-style d-flex justify-content-center text-white",staticStyle:{"z-index":"2"}},[_c('div',{staticClass:"m-auto"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }